export const REGEXP = {
  number: /^\d*$/,
  mobile: /^1[345789]{1}\d{9}$/,
  telephone: /^\d{3}-\d{8}$|^\d{4}-\d{7,8}$/,
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  numArray: /^[\d\s,]*$/i,
};

export default REGEXP;
